import axios from "axios";
import authService from "../../routes/authService";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const OptionsService = {
  getOptionsByType: async (type) => {
    try {
      const token = authService.getToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const response = await axios.get(`${API_BASE_URL}/options/${type}`, {
        headers: headers,
      });
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao buscar opções do tipo ${type}:`,
        error.response?.data || error.message
      );
      throw error;
    }
  },

  createOption: async (optionData) => {
    try {
      const token = authService.getToken();
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await axios.post(`${API_BASE_URL}/options`, optionData, {
        headers: headers,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao criar opção:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default OptionsService;
